<ng-container *ngrxLet="downloads$; let downloads">


  <!-- <div class="">Version {{ firebaseStudioVersion$ | ngrxPush }}</div> -->

  <div class="download-links">
    <a
      mat-flat-button
      (click)="onDownloadPC()"
      color="primary"
      [href]="downloads.windows">
      WINDOWS
      <mat-icon>file_download</mat-icon>
    </a>

    <a
      mat-flat-button
      color="primary"
      (click)="onDownloadMacIntel()"
      [href]="downloads.mac">
      MAC INTEL
      <mat-icon>file_download</mat-icon>
    </a>

    <a
      (click)="onDownloadMacM1()"
      mat-flat-button
      color="primary"
      [href]="downloads.macm1">
      MAC M1
      <mat-icon>file_download</mat-icon>
    </a>
  </div>
</ng-container>
